"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ModelHelper = /** @class */ (function () {
    function ModelHelper() {
    }
    /**
     * Map a property
     * @param {any} source Source object
     * @param {any} target Target object
     * @param {string | number} targetKey Target key
     * @param {any} targetMapCtor Target constructor
     * @param {string | number} sourceKey Source key
     */
    ModelHelper.map = function (source, target, targetKey, targetMapCtor, sourceKey) {
        if (sourceKey === void 0) { sourceKey = targetKey; }
        ModelHelper.mapForeign(source, sourceKey, target, targetKey, targetMapCtor);
    };
    /**
     * Map a property
     * @param {any} source Source object
     * @param {string | number} sourceKey Source key
     * @param {any} target Target object
     * @param {string | number} targetKey Target key
     * @param {any} targetMapCtor Target constructor
     */
    ModelHelper.mapForeign = function (source, sourceKey, target, targetKey, targetMapCtor) {
        if (source === undefined || source === null) {
            return;
        }
        var value = source[sourceKey];
        if (value === undefined) {
            return;
        }
        if (Array.isArray(value)) {
            target[targetKey] = value.map(function (item) {
                return ModelHelper.convertValue(item, targetMapCtor);
            });
        }
        else {
            target[targetKey] = ModelHelper.convertValue(value, targetMapCtor);
        }
    };
    /**
     * Convert a value to a specific type
     * @param {any} value Value to convert
     * @param {any} type Converts the value to this type
     * @returns {any}
     */
    ModelHelper.convertValue = function (value, type) {
        if (value !== undefined && value !== null && type) {
            if (typeof type.map === 'function') {
                return type.map(value);
            }
            else {
                return new type(value);
            }
        }
        return value;
    };
    /**
     * Maps a array to a typed array
     * @param Type Constructor of a map able type
     * @param dataArray Data array
     */
    ModelHelper.mapArray = function (Type, dataArray) {
        if (Array.isArray(dataArray)) {
            return dataArray.map(function (dataItem) { return Type.map(dataItem); });
        }
        return [Type.map(dataArray)];
    };
    /**
     * Map a property asynchron
     * @param {any} source Source object
     * @param {any} target Target object
     * @param {string | number} targetKey Target key
     * @param {any} targetMapCtor Target constructor
     * @param {string | number} sourceKey Source key
     * @returns {Promise<T>}
     */
    ModelHelper.mapAsync = function (source, target, targetKey, targetMapCtor, sourceKey) {
        if (sourceKey === void 0) { sourceKey = targetKey; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ModelHelper.mapForeignAsync(source, sourceKey, target, targetKey, targetMapCtor)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Map a property asynchron
     * @param {any} source Source object
     * @param {string | number} sourceKey Source key
     * @param {any} target Target object
     * @param {string | number} targetKey Target key
     * @param {any} targetMapCtor Target constructor
     * @returns {Promise<T>}
     */
    ModelHelper.mapForeignAsync = function (source, sourceKey, target, targetKey, targetMapCtor) {
        return __awaiter(this, void 0, void 0, function () {
            var value, _a, _b, _c, _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        // Nothing to do
                        if (source === undefined || source === null) {
                            return [2 /*return*/, target];
                        }
                        value = source[sourceKey];
                        if (!Array.isArray(value)) return [3 /*break*/, 2];
                        _a = target;
                        _b = targetKey;
                        return [4 /*yield*/, Promise.all(value.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, ModelHelper.convertValueAsync(item, targetMapCtor)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a[_b] = _e.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(value !== undefined)) return [3 /*break*/, 4];
                        _c = target;
                        _d = targetKey;
                        return [4 /*yield*/, ModelHelper.convertValueAsync(value, targetMapCtor)];
                    case 3:
                        _c[_d] = _e.sent();
                        _e.label = 4;
                    case 4: 
                    // Return target
                    return [2 /*return*/, target];
                }
            });
        });
    };
    /**
     * Convert a value to a specific type asynchron
     * @param {any} value Value to convert
     * @param {{new(...args: any[]): T}} type Converts the value to this type
     * @returns {Promise<any>}
     */
    ModelHelper.convertValueAsync = function (value, type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(value !== undefined && value !== null && type)) return [3 /*break*/, 3];
                        if (!(typeof type.map === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, type.map(value)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, new type(value)];
                    case 3: return [2 /*return*/, value];
                }
            });
        });
    };
    /**
     * Maps a array to a typed array asynchron
     * @param {{new(...args: any[]): T}} type Constructor of a map able type
     * @param dataArray Data array
     * @return {Promise<T[]>}
     */
    ModelHelper.mapArrayAsync = function (type, dataArray) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Array.isArray(dataArray)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(dataArray.map(function (dataItem) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, type.map(dataItem)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); }))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, type.map(dataArray)];
                    case 3: return [2 /*return*/, [_a.sent()]];
                }
            });
        });
    };
    /**
     * Map the source to a target property
     * @param source Property value
     * @param target Target value
     * @param targetKey Target key
     * @return {any}
     */
    ModelHelper.mapToProperty = function (source, target, targetKey) {
        if (source !== undefined) {
            target[targetKey] = source;
        }
        return target;
    };
    /**
     * Get an autonomously plain object from model
     */
    ModelHelper.getPlainObject = function (model) {
        var obj = {};
        // Process array
        if (Array.isArray(model)) {
            return model.map(function (element) {
                return ModelHelper.getPlainObject(element);
            });
        }
        // Process primitives
        if (!model || typeof model !== 'object') {
            return model;
        }
        // Process model object
        for (var property in model) {
            if (model.hasOwnProperty(property) && typeof model[property] !== 'function') {
                // Property is array
                if (Array.isArray(model[property])) {
                    obj[property] = model[property].map(function (element) {
                        return model.getPlainObject(element);
                    });
                    // Property is primitive
                }
                else if (!model[property] || typeof model[property] !== 'object') {
                    obj[property] = model[property];
                    // Property is object
                }
                else if (typeof model[property] === 'object') {
                    // Property is a model
                    if (model[property].getPlainObject) {
                        obj[property] = model[property].getPlainObject();
                        // Property is an other object
                    }
                    else {
                        obj[property] = Object.assign({}, model[property]);
                    }
                }
            }
        }
        // Return plain object
        return obj;
    };
    return ModelHelper;
}());
exports.ModelHelper = ModelHelper;
//# sourceMappingURL=model.helper.js.map